
import { defineComponent, SetupContext } from 'vue';
import { header } from '@/common/seo';

export default defineComponent({
    components: {},
    layout() {
        return 'empty';
    },
    setup(_: unknown, ctx: SetupContext) {},
    head() {
        const head = header(this);
        return {
            ...head,
        };
    },
});
